import {api} from '../../contexts/AuthContext';

// Settings API
export const settingsApi = {
    getAll: async (): Promise<Array<{
        id: string;
        key_name: string;
        value: any;
        value_type: 'boolean' | 'string' | 'number' | 'json';
        description?: string;
        created_at: Date;
        updated_at: Date;
        updated_by?: string;
    }>> => {
        const response = await api.get('/api/settings');
        return response.data.settings;
    },

    getPublic: async (): Promise<Array<{
        id: string;
        key_name: string;
        value: any;
        value_type: 'boolean' | 'string' | 'number' | 'json';
        description?: string;
        created_at: Date;
        updated_at: Date;
        updated_by?: string;
    }>> => {
        const response = await api.get('/api/settings/public');
        return response.data.settings;
    },

    get: async (key: string): Promise<{
        id: string;
        key_name: string;
        value: any;
        value_type: 'boolean' | 'string' | 'number' | 'json';
        description?: string;
        created_at: Date;
        updated_at: Date;
        updated_by?: string;
    }> => {
        const response = await api.get(`/api/settings/${key}`);
        return response.data.setting;
    },

    update: async (key: string, value: any, description?: string): Promise<{
        id: string;
        key_name: string;
        value: any;
        value_type: 'boolean' | 'string' | 'number' | 'json';
        description?: string;
        created_at: Date;
        updated_at: Date;
        updated_by?: string;
    }> => {
        const response = await api.put(`/api/settings/${key}`, {value, description});
        return response.data.setting;
    },

    toggleClickHouse: async (enabled: boolean): Promise<{
        success: boolean;
        setting: any;
        message: string;
    }> => {
        const response = await api.post('/api/settings/clickhouse/toggle', {enabled});
        return response.data;
    },

    delete: async (key: string): Promise<void> => {
        await api.delete(`/api/settings/${key}`);
    },

    uploadGCPServiceAccount: async (formData: FormData): Promise<{
        success: boolean;
        message: string;
        projectId: string;
        serviceAccountEmail: string;
    }> => {
        const response = await api.post('/api/settings/gcp/service-account', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },

    getGCPServiceAccountStatus: async (): Promise<{
        success: boolean;
        uploaded: boolean;
        projectId?: string;
        serviceAccountEmail?: string;
        message?: string;
    }> => {
        const response = await api.get('/api/settings/gcp/service-account/status');
        return response.data;
    }
};
